import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getCountries = async (params?: { subscribed: boolean }) => {
  try {
    const { data } = await axiosInstance.get("/v1/countries", { params });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
